import { modulePaths } from '@/routes/paths';
import type { CalendarEventFilters, CalendarViewMode } from '@/modules/calendar/types';

export type CalendarUrlParams = CalendarEventFilters & {
  view?: CalendarViewMode;
  date?: string;
};

export function buildCalendarSearchParams(
  params: CalendarUrlParams,
): URLSearchParams {
  const sp = new URLSearchParams();
  if (params.view) sp.set('view', params.view);
  if (params.date) sp.set('date', params.date);
  if (params.itemId) sp.set('item', params.itemId);
  if (params.categoryId) sp.set('category', params.categoryId);
  if (params.status && params.status !== 'all') sp.set('status', params.status);
  return sp;
}

export function buildCalendarPath(params: CalendarUrlParams = {}): string {
  const sp = buildCalendarSearchParams(params);
  const q = sp.toString();
  return q ? `${modulePaths.calendar}?${q}` : modulePaths.calendar;
}

export function parseCalendarSearchParams(
  searchParams: URLSearchParams,
): CalendarUrlParams {
  const view = searchParams.get('view');
  const date = searchParams.get('date') ?? undefined;
  const itemId = searchParams.get('item') ?? undefined;
  const categoryId = searchParams.get('category') ?? undefined;
  const statusRaw = searchParams.get('status');

  const params: CalendarUrlParams = {};
  if (view === 'month' || view === 'week' || view === 'day') {
    params.view = view;
  }
  if (date) params.date = date;
  if (itemId) params.itemId = itemId;
  if (categoryId) params.categoryId = categoryId;
  if (
    statusRaw === 'draft' ||
    statusRaw === 'confirmed' ||
    statusRaw === 'in_progress' ||
    statusRaw === 'completed' ||
    statusRaw === 'cancelled'
  ) {
    params.status = statusRaw;
  }
  return params;
}
